export const touchedSection = {
  // per data presunta
  datePresumedStart: true,
  datePresumedEnd: true,
  notePresumed: true,
  // per data certa
  dateDeath: true,
  timeDeath: true,
  // italian form
  italian: {
    municipality: {
      code: true,
      id: true,
    },
  },
  authority: true,
  otherAuthority: true,
  dateCommunication: true,
  numberAppearing: true,
  typeCommunication: {
    id: true,
  },
  dateConferralDecree: true,
  dateNotificationDecree: true,
  extremesDecree: true,
  dateRegistrationCourt: true,
  isInterestedPresent: true,
  authorityPostAddress: true,
  summaryStatement: true,
  presentationDocument: true,
  certificateReleaseFrom: true,
  certificateDate: true,
  conceivedMonth: true,
  isIncestuousSonSentence: true,
  documentDateFormation: true,
  judgmentPublicationDate: true,
  effectiveDateSentence: true,
  documentExtremes: true,
  nameInstitution: true,
  documentDescription: true,
  consulate: {
    id: true,
  },
  dateTranscription: true,
  templateTranscription: true,
  templateTranscriptionText: true,
  applicant: true,
  typeRequest: true,
  hiringTiming: true,
  foreign: {
    state: true,
    municipality: true,
    municipalityAire: true,
    province: true,
    otherState: true,
    locationForeignBirth: true,
    locationForeign: true,
    consulate: true,
  },
  actForm: {
    italian: {
      municipality: true,
      otherMunicipality: true,
      province: true,
      location: true,
    },
    typeEvent: true,
    dateAct: true,
    register: true,
    year: true,
    portion: true,
    volume: true,
    serie: true,
    municipalNumber: true,
    idAnsc: true,
  },
  typeResidence: true,
  typeService: true,
  nationEmployment: true,
  reasonLossCitizenship: true,
  effectiveTime: true,
  descriptionsReasonRecovery: true,
  typologyConsent: true,
  typeDeclaration: true,
  changeSurname: true,
  dateMarriage: true,
  conditionsItem: {
    id: true,
    value: true,
  },
  actComposition: true,
  reasonLackConsent: true,
  parentCitizenship: true,
  sentenceRecognition: true,
  parentTransmittedCitizenship: true,
  dateOutcomeVerification: true,
  assessmentResult: true,
  parentRecognition: true,
  dateMeasureMayor: true,
  dateOath: true,
  extremesOath: true,
  dateEffectiveMeasure: true,
  protocolNumber: true,
  newName: true,
  oldSurname: true,
  newSurname: true,
  numberHolders: true,
  dateDeclaration: true,
  dateChangeSurname: true,
  typeMutation: true,
  parentChangedSurname: true,
  measureExchangeSurname: true,
  nameAdded: true,
  surnameAdded: true,
  typeDisappearance: true,
  dateLastSighting: true,
  nameInstituteAbandonedMinor: true,
  dateEvent: true,
  timeEvent: true,
  numberWitnesses: true,
  opposition: true,
  genericImpediment: true,
  dateIncorporationCertificate: true,
  reason: true,
  propertyRegime: true,
  lawPropertyRegime: true,
  nameNotary: true,
  surnameNotary: true,
  notarialDistrict: true,
  repertoireNumber: true,
  collectionNumber: true,
  datePropertyRegime: true,
  dataDelegate: true,
  textDelegate: true,
  ageDefect: true,
  relationship: true,
  minorGroomAssistance: true,
  minorWifeAssistance: true,
  place: true,
  houseNumber: true,
  italianDelegating: {
    municipality: true,
    otherMunicipality: true,
    province: true,
    location: true,
  },
  foreignDelegating: {
    state: true,
    municipality: true,
    municipalityAire: true,
    province: true,
    otherState: true,
    locationForeignBirth: true,
    locationForeign: true,
    consulate: true,
  },
  dataSend: true,
  otherTypeCommunicationDescription: true,
  dataReception: true,
  impedimentUnitedCivilly: true,
  address: true,
  dataCivilUnion: true,
  typeActToTranscribed: true,
  dataStart: true,
  dataEnd: true,
  presentationDocumentRecognition: true,
  publication: true,
  declarant: true,
  ritualReligious: {
    id: true,
    value: true,
  },
  otherRitualReligious: true,
  maintenanceAllowance: true,
  judicialAuthority: true,
  dateAgreementConfirmation: true,
  celebratedBy: true,
  typeAgreement: true,
  typeSeparation: true,
  typeMeasure: true,
  receiptDocument: true,
  dateStipulation: true,
  depositDate: true,
  surnameEditor: true,
  nameEditor: true,
  gender: true,
  timeDocumentFormation: true,
  dateReconciliation: true,
  typeModificationMarriage: true,
  typeEvent: true,
  consentReturnedBefore: true,
  ufcDelegate: true,
  numberLawCitizenship: true,
  margin: true,
  effectiveDate: true,
  typeExtremesDecree: true,
  extremesPec: true,
  emergencyRegister: {
    id: true,
    value: true,
  },
};

export const touchedSubject = {
  generality: {
    address: true,
    attorney: true,
    birthDate: true,
    birthPlace: true,
    birthTime: true,
    civilStatus: true,
    reasonChoosingSurname: {
      id: true,
      value: true,
    },
    clarificationSurname: true,
    conditionsItem: {
      id: true,
      value: true,
    },
    conditionsItemSignatory: {
      id: true,
      value: true,
    },
    reasonImpedimentSignatory: true,
    fiscalCode: true,
    nationality: true,
    otherCitizenship: true,
    foreign: {
      state: true,
      municipality: true,
      municipalityAire: true,
      province: true,
      otherState: true,
      locationForeignBirth: true,
      locationForeign: true,
      consulate: true,
    },
    foreignResidence: {
      state: true,
      municipality: true,
      municipalityAire: true,
      province: true,
      otherState: true,
      locationForeignBirth: true,
      locationForeign: true,
      consulate: true,
    },
    italian: {
      municipality: true,
      otherMunicipality: true,
      province: true,
      location: true,
    },
    italianResidence: {
      municipality: true,
      otherMunicipality: true,
      province: true,
      location: true,
    },
    gender: true,
    name: true,
    surnameItem: true,
    reasonImpedimentItem: true,
    surname: true,
    rolo: true,
    relationship: true,
    verificationTypeItem: {
      id: true,
      value: true,
    },
    birthPlaceItem: {
      id: true,
      value: true,
    },
    reasonDelay: true,
    bornTypology: true,
    dateStartResidence: true,
    reasonLossCitizenship: true,
    typeBirthPlace: true,
    currentTwin: true,
    allTwins: true,
    // data document
    documentNumber: true,
    documentTypology: true,
    documentExpiryDate: true,
    documentReleaseDate: true,
    documentReleaseFrom: true,
    civilStatusItem: {
      id: true,
      value: true,
    },
    ufcDelegate: true,
    roloSecretary: true,
    verificationOfWill: true,
    dateCommunication: true,
    protocol: true,
    lawyerForum: true,
    necropsyDate: true,
    newSurname: true,
    typeAct: true,
    idActPaper: true,
    idActDigital: true,
    italianAct: {
      municipality: true,
      otherMunicipality: true,
      province: true,
      location: true,
    },
  },
};
